import { css } from '@emotion/core'

export default function appModeNoSelectCss(appMode) {
  const touchScreen = appMode === 'STATION'

  const touchCss = css`
    body {
      ${
        touchScreen
          ? `-webkit-touch-callout: none;
        -webkit-user-select: none;
         -khtml-user-select: none;
           -moz-user-select: none;
            -ms-user-select: none;
                user-select: none;
      `
          : ''
      }
    }
  `
  return touchCss
}
